module.exports = __webpack_public_path__ + "img/Back2.abcc24d.png";